import { map, pick } from 'lodash'

const transformToSaveDietsAndDietCategoriesArgs = data =>
  map(data, (dietCategory, dietCategoryIndex) => ({
    ...pick(dietCategory, ['id', 'name', 'isCurationEnabled']),
    position: dietCategoryIndex,
    children: map(dietCategory.children, (diet, index) => ({
      ...pick(diet, ['id', 'name', 'parentId', 'isCurationEnabled']),
      position: index,
    })),
  }))

export default transformToSaveDietsAndDietCategoriesArgs
